import React from "react";

import { Container, Navbar, NavbarBrand } from "react-bootstrap";

import classNames from "classnames";
import { ReactSVG } from "react-svg";

import logo from "@assets/rrs-logo.svg";

import styles from "./PublicHeaderMinimal.module.scss";

export const PublicHeaderMinimal = () => {
  return (
    <Navbar expand="md" sticky="top" className={`${styles["public-header"]} shadow-sm`}>
      <Container className="p-0">
        <NavbarBrand className={classNames(styles["logo"], "d-flex align-items-center")}>
          <ReactSVG src={logo} />
        </NavbarBrand>
      </Container>
    </Navbar>
  );
};
